// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__s1V1g","activeFooter":"Footer_activeFooter__rO4gg","unactiveFooter":"Footer_unactiveFooter__5rK-B","link_container":"Footer_link_container__AGEup"};